export default {
    settings: {
        title: 'GLOBALNA PODESAVANJA',
        mainMenu: 'Glavni menu',
        footerMenu: 'Futer menu',
        phone: 'Telefon',
        fax: 'Fax',
        email: 'E-posta',
        address: 'Adresa',
        city: 'Grad',
        categoryId: 'Category IDs',
        numDocument: 'Num. of documents per category',
        save: 'Snimi'
    },
    menu: {
        position: 'Pozicija',
        parent: 'Parent',
        pageOfUrl: 'Page of URL'
    }
};